export abstract class Dimensions {
  width: number;
  height: number;
  maxHeight: number;
}
